// Module
var code = `<div appHeaderBar>
    <header-bar-title>Pay by Card</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true" [pmcId]="property.hoa.pmc.couponId" [hoaId]="property.hoa.couponId" [propertyId]="property.couponId">
    <app-cobrand-header [property]="property.nickname" [manager]="property.hoa.pmc.name" [association]="property.hoa.name" [makePayment]="true"></app-cobrand-header>
    <form name="GuestPaymentCard" id="GuestPaymentCard" tid="GuestPaymentCard" (submit)="false" #GuestPaymentCard="ngForm">
        <!-- disable submitting the form, or set all buttons to [type=button] so they aren't treated as submit buttons -->
        <div class="HOA-container">
            <div class="HOA-container__header">
                <h1 class="HOA-container__header-text" tid="oneTimePaymentLabel">Pay by Card</h1>
                <app-pmc-logo class="u-right" [property]="property"></app-pmc-logo>
            </div>
            <div class="HOA-container__content">
                <app-card-detail-add *ngIf="!editCard"
                        [props]="cardProps"
                        [addressDisabled]="prefillAddressForm !== UNSELECTED || true"
                        [cardDisabled]="true"
                        [showNickName]="false"
                        [showDefault]="false"
                        (onFormComplete)="onCardValid(\$event)">
                </app-card-detail-add>
                <app-card-detail-edit *ngIf="editCard"
                         [props]="cardEditProps"
                         [addressDisabled]="prefillAddressForm !== UNSELECTED || true"
                         [cardDisabled]="true"
                         [showNickName]="false"
                         [showDefault]="false"
                         [isGuest]="true"
                         (onFormComplete)="onCardValid(\$event)"
                         (onClearCard)="toggleEditCard()">
                </app-card-detail-edit>

                <div class="HOA-container__content-hrule HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--100 u-mT5"></div>
                <app-card-address
                        [props]="addressProps"
                        [selectProperty]="false"
                        (addressFormValidate)="onAddressValid(\$event)" >
                </app-card-address>

                <div class="HOA-container__content-hrule HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--100 u-mT5"></div>

                <div *ngIf="!paymentRequest?.details">
                    <div tid="paymentDetailsLabel" id="paymentDetailsLabel" class="HOA-flextable-component__subheader u-mT3 u-mB7">
                        Payment Details
                    </div>
                    <!--Hiding the balance summary 
                    <app-property-line-item-details [tid]="'PropertyLineItemDetails'"
                            [propertyId]="property.id" [property]="property" [isAnonymous]="true">
                    </app-property-line-item-details> -->
                    <div class="HOA-flextable-component HOA-flextable-component__form">
                        <div [ngClass]="{ 'is-invalid': paymentAmtErrMsg }" class="Field HOA-flextable-component__cell-input HOA-CheckingAccount-padding-top-sm12-lg2">
                            <label tid="paymentAmountLabel" id="paymentAmountLabel" for="paymentAmount" class="Field-label">
                                Payment Amount
                                <span class="asterisk-required">&nbsp;&#42;</span>
                                <a *ngIf="!hideResetAmountLink" (click)="resetPaymentAmount()"
                                        class="Field--xs HOA-link HOA-guest-payment-right-align" tid="resettoamountdue" id="resettoamountdue">Reset Original Amount</a>
                            </label>
                            <div  class="Field-addonBox">
                                <input type="text" id="paymentAmount" tid="paymentAmount" class="Input" maxlength="9" name="paymentAmount" custom-currency required
                                       [(ngModel)]="paymentAmount" (change)="onPmtAmtInputChange()" (focus)="onPmtAmtInputFocus()" (blur)="onPmtAmtInputBlur()"
                                       [attr.aria-invalid]="!!paymentAmtErrMsg" [attr.aria-describedby]="paymentAmtErrMsg && 'paymentAmount-error' || undefined"
                                />
                                <button type="button" class="Field-addon" (click)="clearPaymentAmount()"
                                        aria-label="Click to clear payment amount" tid="clearpaymentamount">&times;</button>
                            </div>
                            <span class="Field-error" tid="paymentAmount-error" id="paymentAmount-error">{{paymentAmtErrMsg}}</span>
                        </div>

                        <div class="Field HOA-flextable-component__cell-input HOA-CheckingAccount-padding-top-sm12-lg2">
                            <div class="pmt-date-container"><label for="paymentDate" class="Field-label">Payment Date</label>
                                <div class="Field-addonBox">
                                    <input type="text" [ngModel]="paymentDateDisplay" name="paymentDateDisplay" maxlength="20"
                                           class="Input" id="paymentDate" tid="paymentDate" aria-required="false" disabled>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="HOA-container__content-hrule HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--100 "></div>
                </div>
                <div class="HOA-flextable-component HOA-flextable-component__form">
                    <div class="Field HOA-flextable-component__cell-input">
                        <div class="HOA-flextable-component__subheader u-mB7">Payment Summary</div>
                        <div *ngIf="paymentRequest?.details">
                            <div *ngFor="let cartItem of paymentRequest.details" class="HOA-flex-component u-pB6 HOA-make-payment-item-row">
                                <div class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">
                                    <span>{{cartItem.description}}</span>
                                </div>
                                <div class="HOA-make-payment-item-row-amount u-textRight">
                                    <span>{{cartItem.amount * cartItem.qty | currency}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="HOA-flex-component u-pB6 HOA-make-payment-item-row u-pT6">
                            <div tid="summaryPaymentAmountLabel" id="summaryPaymentAmountLabel" class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">
                                <span *ngIf="!paymentRequest?.details">Payment Amount</span>
                                <span *ngIf="paymentRequest?.details">Items</span>
                            </div>
                            <div tid="summaryPaymentAmount" id="summaryPaymentAmount" class="HOA-make-payment-item-row-amount u-textRight">
                                <span>{{paymentAmount || 0 | currency}}</span>
                            </div>
                        </div>
                        <!--Administrative fee-->
                        <div class="HOA-flex-component u-pB6 HOA-make-payment-item-row">
                            <div tid="convenienceFeeLabel" id="convenienceFeeLabel" class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">
                                <span>Administrative Fee</span>
                            </div>
                            <div tid="convenienceFee" id="convenienceFee" class="HOA-make-payment-item-row-amount u-textRight">
                                <span>{{convenienceFee  || 0 | currency}}</span>
                            </div>
                        </div>
                        <!--Total-->
                        <div class="HOA-flex-component u-pB6 HOA-make-payment-item-row">
                            <div tid="summaryTotalLabel" id="summaryTotalLabel" class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">
                                <span class="u-fontBold u-pR1">Total Amount</span>
                            </div>
                            <div tid="totalPaymentAmount" id="totalPaymentAmount" class="HOA-make-payment-total-amount-label u-textRight">
                                <span class="HOA-make-payment-amount-total">{{totalPaymentAmount || 0 | currency}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="HOA-flextable-component HOA-flextable-component__form u-pB4">
                    <div class="HOA-flextable-component__cell-input" style="width: auto">
                        <input type="checkbox" id="tcCheckbox" name="tcCheckbox" tid="tcCheckbox" class="Field u-cf" style="margin-bottom: 26px; accent-color: #00505c"
                               [(ngModel)]="tcCheckbox" [ngClass]="{'is-invalid': false}">
                        <label tid="tcCheckbox-label" class="HOA-font-light">I agree to pay the total amount including any fees as shown above.</label>
                        <span tid="disclaimerText" id="disclaimerText" class="HOA-Field-detail">Payments are processed Monday through Friday, excluding holidays. Payments submitted on weekends or holidays may be delayed.</span>
                    </div>
                    <div class="HOA-flextable-component__cell-input"></div>
                </div>

                <div class="u-pT2 HOA-flex-component HOA-flextable-component__flex-end">
                    <button name="back" id="back" tid="back" class="Button Button--link HOA-make-payment-button"
                            (click)="onClickBack()" type="button"
                    >Back</button>
                    <button name="submit" id="submit" tid="submit" type="submit" class="Button Button--blue HOA-make-payment-button"
                            [ifOverFlowXClass]="'Button--overflowX'"
                            [disabled]="invalid()" (click)="onSubmit()"
                    >Next</button>
                </div>
                <div tid="requiredText" id="requiredText" class="u-pT2 HOA-flex-component HOA-font-fine-print"><span class="asterisk-required">&#42;</span>&nbsp;Indicates required field</div>
            </div>
        </div>
    </form>
</app-page-content>
`;
// Exports
module.exports = code;